module.exports = __webpack_public_path__ + "media/images/front/treatment_support/icon_home-dc6a087b317e454da31fb4951dc1ccd9.svg";